export const hasDismissedBannerBetweenDates = ({
  dismissedOn,
  startDate,
  endDate,
}: {
  dismissedOn: string | null;
  startDate: string | null;
  endDate: string | null;
}): boolean => {
  return Boolean(
    startDate &&
      endDate &&
      dismissedOn &&
      new Date(startDate) < new Date(dismissedOn) &&
      new Date(endDate) > new Date(dismissedOn)
  );
};
